/**
 * 商城客户爱车评估记录
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, DatePicker, Select, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

//爱车评估详细
import VehicleEvaluateDetail from './VehicleEvaluateDetail';

import DictSelect from '../../ui/DictSelect';

import http from '../../../axios/http';

import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

class   VehicleEvaluateIndex extends React.Component {

    columns = [{
        title: '品牌',
        dataIndex: 'vehicleBrandName',
        width: '10%',
    }, {
        title: '车系',
        dataIndex: 'vehicleFamilyName',
        width: '10%',
    }, {
        title: '款式',
        dataIndex: 'vehicleVersionName',
        width: '20%',
    }, {
        title: '上牌时间',
        dataIndex: 'plateDate',
        width: '10%',
    }, {
        title: '表显里程/万公里',
        dataIndex: 'mileage',
        width: '10%',
    }, {
        title: '估价类型',
        dataIndex: 'sellFlag',
        width: '10%',
        format: { 0: '买车估价', 1: '卖车估价' }
    }, 
    // {
    //     title: '是否预约到店评估',
    //     dataIndex: 'hasAppointment',
    //     width: '10%',
    //     format: { 0: '否', 1: '是' }
    // }, {
    //     title: '卖车意愿',
    //     dataIndex: 'sellExpect',
    //     width: '15%',
    // }, 
    
    {
        title: '评估时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, text)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    
    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/vehicleEvaluate/download',
            data: queryData,
            fileName: "爱车评估记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }



    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    detail = (info, e) => {
        http.get({
            url: '/vehicleEvaluate/info/'+info,
            success: (res) => {
                res.cityPriceJson = JSON.parse( res.cityPriceJson)
                res.datePriceJson = JSON.parse( res.datePriceJson)
                this.setState({ editData: res, visible: true });
                this.state.initEdit(res);
            },
            error:(res)=>{
               
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (field, key) =>{
        let queryData = this.state.queryData;
        queryData[field] = key;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    dictSelect = (field, dict) =>{
        this.onSelect(field, dict.code);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange}/>
                                <Select onChange={this.onSelect.bind(this,"hasAppointment")} allowClear={true} style={{ margin: '0 10px', width: '150px' }} >
                                    <Select.Option  key="0">未预约精准估价</Select.Option>
                                    <Select.Option  key="1">预约精准估价</Select.Option>
                                </Select>
                                <DictSelect category="VEHICLE_FASTSELL_TIME" 
                                    onSelect={this.dictSelect.bind(this,"sellExpect")}
                                    allowClear={true} style={{ width: '250px' }}
                                />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/vehicleEvaluate/findEvaluatePage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <VehicleEvaluateDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    initEdit={(func) => { this.setState({ initEdit: func }) }}

                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default VehicleEvaluateIndex;